<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tFxB8R/tc-custom/9781488037191.jpg?1705766050726" alt="This image is the cover for the book Bits and Pieces"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bits and Pieces
      </h1>
      <p class="bookDescription body article font2">
        <b>Join </b><b><i>USA TODAY</i></b><b> bestselling author Merline Lovelace as she revisits a classic story of lovers on a mission.</b><br/><br/>As a test pilot working in high-tech weapons development, Colonel Jake McAllister is all business, all the time. So when engineer Maura Phillips joins his team, the no-nonsense Jake is shocked to his very core by the sudden attraction he feels to the brainy beauty. But when Jake and Maura’s very lives come under fire, the colonel will keep close tabs on his self-control and the deadly threats haunting them both. <br/><br/><i>Originally published by Meteor Publishing in 1993, revised edition published by Harlequin in 2005</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Merline Lovelace
      </h2>
      
      <p class="authorDescription body article">As an Air Force officer, Merline Lovelace served at bases all over the world. When she hung up her uniform for the last time, she combined her love of adventure with a flare for storytelling. She&#39;s now produced more than 100 action-packed novels. Over twelve million copies of her works are in print in 30 countries. Named Oklahoma&rsquo;s Writer of the Year and Female Veteran of the Year, Merline is also a recipient of Romance Writers of America&rsquo;s prestigious Rita Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3dd50deb